import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import centersoftechHorizontal from '../assets/logos/centersoftech-horizontal.webp';
import './Navigation.css';

const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 80);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`navigation ${isScrolled ? 'scrolled' : ''}`}>
      <nav className="nav-container">
        <Link to="/" className="nav-logo">
          <img src={centersoftechHorizontal} alt="CenterSoftech" width="156" height="42" />
        </Link>
      </nav>
    </header>
  );
};

export default Navigation;
